import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import AcademicModal from "models/academic.modal";
import ClassLinkingModal from "models/classlinking.modal";
import Select from "react-select";
import { toast } from "lib/helper";

const LevelLinking = () => {
  const [modal, setModel] = useState(false);
  const toggle = () => {
    setModel(!modal);
  };
  const [modal1, setModel1] = useState(false);
  const toggle1 = () => {
    setModel1(!modal1);
  };
  const [acadamicdata, setAcadamicdata] = useState(null);
  const Acadamic = async () => {
    await AcademicModal.list()
      .then((responce) => {
        setAcadamicdata(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const [boarddata, setBoarddata] = useState(null);

  const Board = async (id) => {
    setClassdata(null);
    setSubjectdata(null);
    await AcademicModal.listbyidAcademicSubCategory(id)

      .then((responce) => {
        setBoarddata(responce?.data?.data);
        console.log("rrrrr", responce);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const [boarddatapop, setBoarddatapop] = useState(null);

  const Boardpop = async (id) => {
    setClassdatapop(null);
    setSubjectdatapop(null);
    if (id) {
      await AcademicModal.listbyidAcademicSubCategory(id)

        .then((responce) => {
          setBoarddatapop(responce?.data?.data);
        })
        .catch((error) => {
          console.log("error", error);
        });
    } else {
      setBoarddatapop(null);
    }
  };
  const [classdata, setClassdata] = useState(null);
  const [classid, setClassid] = useState(null);
  const Class = async (id) => {
    await AcademicModal.listbyidAcademicSubCategory(id)
      .then((responce) => {
        setClassdata(responce?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const [classdatapop, setClassdatapop] = useState(null);
  const [classpopid, setClasspopid] = useState(null);
  const Classpop = async (id) => {
    await AcademicModal.listbyidAcademicSubCategory(id)
      .then((responce) => {
        setClassdatapop(responce?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const [subjectdata, setSubjectdata] = useState(null);
  const [subjectid, setSubjectid] = useState(null);
  const Subject = async (id) => {
    setClassid(id);
    setSubjectdata(null);
    if (id) {
      await AcademicModal.listbyidAcademicSubCategory(id)
        .then((responce) => {
          setSubjectdata(responce?.data?.data);
        })
        .catch((error) => {
          console.log("error", error);
        });
    } else {
      setSubjectdata(null);
    }
  };
  const [subjectdatapop, setSubjectdatapop] = useState(null);
  const [subjectpopid, setSubjectpopid] = useState(null);
  const Subjectpop = async (id) => {
    //setClasspopid(id);
    //setSubjectdatapop(null);
    if (id) {
      await AcademicModal.listbyidAcademicSubCategory(id)
        .then((responce) => {
          setSubjectdatapop(responce?.data?.data);
        })
        .catch((error) => {
          console.log("error", error);
        });
    } else {
      setSubjectdata(null);
    }
  };
  const [datalist, setDatalist] = useState(null);
 

  const GetAlllist = async () => {
    ClassLinkingModal.GetAll()
      .then((responce) => {
        setDatalist(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  console.log("dataa-d", classdatapop);
  useEffect(() => {
    GetAlllist();
    Acadamic();
  }, []);
  const options = subjectdatapop?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const addlinking = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    //const level1start1 = form.get("level_1start_price");
    //const level1end1 = form.get("level_1end_price");

   // const finallevel1 = {
    //  start_price: level1start1,
    //  end_price: level1end1,
    //};

    //form.append("level_1",finallevel1);

    //const level2start2 = form.get("level_2start_price");
    //const level2end2 = form.get("level_2end_price");

    //const finallevel2 = {
    //  start_price: level2start2,
    //  end_price: level2end2,
    //};

    //form.append("level_2", finallevel2);

    //const level3start3 = form.get("level_3start_price");
    //const level3end3 = form.get("level_3end_price");

    //const finallevel3 = {
     // start_price: level3start3,
     // end_price: level3end3,
   // };

    //form.append("level_3",finallevel3);
    //const level4start4 = form.get("level_4start_price");
    //const level4end4 = form.get("level_4end_price");

    //const finallevel4 = {
     // start_price: level4start4,
     // end_price: level4end4,
   // };

    //form.append("level_4", finallevel4);
    ClassLinkingModal.add(form)
      .then((responce) => {
        GetAlllist();
        toggle1();
      })
      .catch((error) => {});
  };
  const Deletelinking = async(id)=>{
    ClassLinkingModal.delete(id)
    .then((responce) => {
      toast("Delete succesfully","success")
      GetAlllist();
      
    })
    .catch((error) => {});
  }
  return (
    <div className="pt-7 px-4">
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0 w-full">
              <div className="d-flex justify-content-between w-full ">
                <h3 className="mb-0">Level Linking </h3>

                <div className="d-flex flex-row">
                  {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                  {/*<Input
                  className="mr-4"
                  type="text"
                  placeholder="Search"
                  size="sm"
                />*/}
                  <Button
                    size="sm"
                    onClick={toggle1}
                    style={{
                      width: "280px",
                      backgroundColor: "#080278",
                      color: "white",
                      border: "none",
                    }}
                  >
                    +Add Level Linking
                  </Button>
                </div>
              </div>
             
             
             
              
              <div className="d-flex justify-content-end w-100 mt-2"></div>
            </CardHeader>

            <Table className="align-items-center table-flush" responsive>
              <thead>
                <tr style={{ background: "#F6F9FC" }}>
                  <th rowSpan={2} style={{ border: "1px solid lightgray" }}>
                    SN No.
                  </th>
                  <th rowSpan={2} style={{ border: "1px solid lightgray" }}>
                    Class
                  </th>
                  <th rowSpan={2} style={{ border: "1px solid lightgray" }}>
                    Subject
                  </th>
                  <th colSpan={2} style={{ border: "1px solid lightgray" }}>
                    Level 1
                  </th>
                  <th colSpan={2} style={{ border: "1px solid lightgray" }}>
                    Level 2
                  </th>
                  <th colSpan={2} style={{ border: "1px solid lightgray" }}>
                    Level 3
                  </th>
                  <th colSpan={2} style={{ border: "1px solid lightgray" }}>
                    Level 4
                  </th>
                  <th rowSpan={2} style={{ border: "1px solid lightgray" }}>
                    Action
                  </th>
                </tr>
                <tr style={{ background: "#F6F9FC", border: "1px" }}>
                  <th style={{ border: "1px solid lightgray" }}>Start Price</th>
                  <th style={{ border: "1px solid lightgray" }}>End Price</th>
                  <th style={{ border: "1px solid lightgray" }}>Start Price</th>
                  <th style={{ border: "1px solid lightgray" }}>End Price</th>
                  <th style={{ border: "1px solid lightgray" }}>Start Price</th>
                  <th style={{ border: "1px solid lightgray" }}>End Price</th>
                  <th style={{ border: "1px solid lightgray" }}>Start Price</th>
                  <th style={{ border: "1px solid lightgray" }}>End Price</th>
                </tr>
              </thead>

              <tbody>
                {datalist?.data?.length > 0 && // Correct `length` typo
                  datalist.data.map((item, index) => {
                    console.log("map", item);
                    return (
                      <tr
                        key={index}
                        className="vertical-align-middle"
                        style={{ cursor: "pointer", verticalAlign: "middle" }}
                      >
                        <td>{index + 1}</td>
                        <td>{item?.tutorApi_academiccategory?.name}</td>
                        <td>
                          {item?.subject_names?.map((item, index) => {
                            return (
                              <span>
                                {item?.name}
                                {", "}{" "}
                              </span>
                            );
                          })}
                        </td>
                        <td>
                          {item.level_1.start_price || "N/A"}
                            
                        </td>
                        <td>
                          { item.level_1.end_price || "N/A"}
                           
                        </td>
                        <td>
                          {item.level_2.start_price || "N/A"}
                            
                        </td>
                        <td>
                          {item.level_2.end_price || "N/A"}
                        </td>
                        <td>
                          { item.level_3.start_price || "N/A"}
                        </td>
                        <td>
                          {item.level_3.end_price || "N/A"}
                        </td>
                        <td>
                          {item.level_4.start_price|| "N/A"}
                        </td>
                        <td>
                          {item.level_4.end_price || "N/A"
                            }
                        </td>
                        <td
                          className="p-0 pl-4"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <UncontrolledTooltip
                            placement="top"
                            target={`deleteTooltip-${index}`} // Use unique ID
                          >
                            Delete
                          </UncontrolledTooltip>
                          <p
                            style={{
                              margin: "0 8px",
                              fontSize: "15px",
                              color: "red",
                              marginTop: "15px",
                              display: "inline-block",
                              borderRadius: "20%",
                            }}
                            id={`deleteTooltip-${index}`} // Unique ID
                            onClick={()=>{Deletelinking(item?.id)}}
                          >
                            <i className="fas fa-trash"></i>
                          </p>
                        </td>
                      </tr>
                    );
                  })}

                {datalist?.data?.length == "0" && (
                  <tr style={{ textAlign: "center" }}>
                    <td colSpan="6" style={{ verticalAlign: "middle" }}>
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              {/* <TablePagination
              totalPages={parseInt(dataList?.meta?.total_page)}
              currentPage={parseInt(dataList?.meta?.current_page)}
              pageUrl="/admin/messages?"
            /> */}
            </CardFooter>
          </Card>
        </div>
      </Row>

      <Modal isOpen={modal1} toggle={toggle1} size="lg">
        <ModalHeader toggle={toggle1}>
          <h4>Add class Level Linking </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={addlinking}>
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label for="exampleEmail">Acadamic</Label>
                  <Input
                    id="forType"
                    type="select"
                    placeholder="Enter Level Name"
                    onChange={(e) => {
                      Boardpop(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {acadamicdata?.map((item, index) => {
                      return (
                        <option value={item?.id} key={index}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label for="exampleEmail">Board</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="select"
                    onChange={(e) => {
                      Classpop(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {boarddatapop?.map((item, index) => {
                      return (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label for="exampleEmail">Class</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    name="class_id[]"
                    type="select"
                    onChange={(e) => {
                      Subjectpop(e.target.value);
                    }}
                  >
                    {" "}
                    <option value="">Select</option>
                    {classdatapop?.map((item, index) => {
                      return (
                        <option value={item.id} key={index}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Subject</Label>
                  <Select options={options} name="subject_id[]" isMulti />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                {" "}
                <Label for="exampleEmail">Level 1</Label>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label for="exampleEmail">Start price</Label>
                <Input
                  type="number"
                  placeholder="Enter Amount"
                  name="level_1[start_price]"
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail">End price</Label>
                <Input
                  type="number"
                  placeholder="Enter Amount"
                  name="level_1[end_price]"
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                {" "}
                <Label for="exampleEmail">Level 2</Label>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label for="exampleEmail">Start price</Label>
                <Input
                  type="number"
                  placeholder="Enter Amount"
                  name="level_2[start_price]"
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail">End price</Label>
                <Input
                  type="number"
                  placeholder="Enter Amount"
                  name="level_2[end_price]"
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                {" "}
                <Label for="exampleEmail">Level 3</Label>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label for="exampleEmail">Start price</Label>
                <Input
                  type="number"
                  placeholder="Enter Amount"
                  name="level_3[start_price]"
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail">End price</Label>
                <Input
                  type="number"
                  placeholder="Enter Amount"
                  name="level_3[end_price]"
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                {" "}
                <Label for="exampleEmail">Level 4</Label>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label for="exampleEmail">Start price</Label>
                <Input
                  type="number"
                  placeholder="Enter Amount"
                  name="level_4[start_price]"
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail">End price</Label>
                <Input
                  type="number"
                  placeholder="Enter Amount"
                  name="level_4[end_price]"
                />
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle1}>
                Cancel
              </Button>
              {/* 
                    {addsLoadig ? (
                      <Loader color={"blue"} />
                    ) : ( */}
              <Button
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
              >
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle="{toggle1}">
          <h4>Edit Level</h4>
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail"> Level Name</Label>
                  <Input
                    id="forType"
                    type="text"
                    name="name"
                    placeholder="Enter Level Name"
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Price Start</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="number"
                    name="price_start"
                    placeholder="Enter Amount"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Price Up To</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="number"
                    name="price_upto"
                    placeholder="Enter Amount"
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div>
                  <Label for="exampleEmail">Description</Label>
                  <Input type="textarea" placeholder="Enter Description" />

                  <i className="fa-solid fa-xmark" color="danger" />
                </div>

                <Row>
                  <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                    <i
                      className="fa-solid fa-plus"
                      style={{
                        float: "right",
                        fontSize: "20px",
                        color: "blue",
                      }}
                    ></i>{" "}
                    {/* Plus icon to add rows */}
                  </Col>
                </Row>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick="">
                Cancel
              </Button>
              {/* 
                    {addsLoadig ? (
                      <Loader color={"blue"} />
                    ) : ( */}
              <Button
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
              >
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default LevelLinking;
